<template>
  <div class="about">
    <h1>This event page info</h1>
  </div>
</template>
